export default __webpack_public_path__ + "c8920a5aa57c142960bff247daf220a6.png";